import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class StoreCart extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={164} width={182}>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-757 -648)">
            <g transform="translate(759 650)">
              <polygon
                fill="#FE9840"
                points="62.9824 54.9453 63.7074 34.9203 155.2234 38.2293 154.4994 58.2553"
              />
              <path
                d="M114.3135,40.5693 L113.8655,52.9653"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <path
                d="M145.9922,41.7148 L145.5442,54.1118"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <path
                d="M104.8535,40.2275 L104.4055,52.6235"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <polygon
                fill="#FE9840"
                points="52.209 120.4668 40.708 116.0648 59.425 67.1578 70.926 71.5608"
              />
              <path
                d="M54.1025,90.5088 L59.2985,92.4968"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <path
                d="M60.9648,72.5762 L66.1618,74.5652"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <path
                d="M52.4844,94.7373 L57.6804,96.7253"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <path
                d="M50.8662,98.9658 L56.0622,100.9538"
                stroke="#FEC391"
                strokeWidth="4"
              />
              <polygon
                fill="#00A7DB"
                points="64.9434 118.1846 63.0214 104.0426 167.7234 89.8156 169.6454 103.9566"
              />
              <path
                d="M157.6182,97.1895 L158.7392,105.4385"
                stroke="#75CFEC"
                strokeWidth="4"
              />
              <polygon
                fill="#75CFEC"
                points="96.084 109.752 95.283 103.86 136.583 98.248 137.384 104.14"
              />
              <polygon
                fill="#23C991"
                points="69.0586 103.1123 66.3726 83.2813 157.1206 70.9903 159.8066 90.8213"
              />
              <polygon
                fill="#86E0C2"
                points="100.0439 94.0596 98.7669 84.6296 144.0039 78.5016 145.2809 87.9326"
              />
              <polygon
                fill="#23C991"
                points="66.5449 35.0713 67.2869 15.0733 143.2219 17.8893 142.4799 37.8873"
              />
              <polygon
                fill="#86E0C2"
                points="93.1904 31.2441 93.5444 21.7341 131.3974 23.1391 131.0444 32.6481"
              />
              <polygon
                fill="#00A7DB"
                points="163.8105 57.9336 163.3945 70.2416 57.7895 66.6706 58.2065 54.3626"
              />
              <path
                d="M146.1973,66.3926 L146.3923,60.6116"
                stroke="#75CFEC"
                strokeWidth="4"
              />
              <path
                d="M153.8975,66.6533 L154.0935,60.8723"
                stroke="#75CFEC"
                strokeWidth="4"
              />
              <polygon
                fill="#75CFEC"
                points="90.9756 64.5254 91.1706 58.7444 136.7956 60.2874 136.5996 66.0684"
              />
              <g>
                <path
                  d="M174.835,105.4609 L37.355,124.1489 L28.31,30.5349 L174.483,30.5349 C175.926,30.5349 177.095,31.7049 177.095,33.1479 L177.095,102.8729 C177.095,104.1799 176.13,105.2849 174.835,105.4609 Z"
                  stroke="#DADADA"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <polyline
                  stroke="#DADADA"
                  strokeWidth="4"
                  strokeLinecap="round"
                  points="0 0 26.231 7.854 37.99 138.105 159.527 138.105"
                />
                <path
                  d="M78.2412,152.5029 C78.2412,157.7479 73.9892,161.9999 68.7442,161.9999 C63.4982,161.9999 59.2462,157.7479 59.2462,152.5029 C59.2462,147.2569 63.4982,143.0049 68.7442,143.0049 C73.9892,143.0049 78.2412,147.2569 78.2412,152.5029"
                  fill="#75CFEC"
                />
                <path
                  d="M73.3418,152.5029 C73.3418,155.0419 71.2828,157.1009 68.7438,157.1009 C66.2038,157.1009 64.1458,155.0419 64.1458,152.5029 C64.1458,149.9629 66.2038,147.9039 68.7438,147.9039 C71.2828,147.9039 73.3418,149.9629 73.3418,152.5029"
                  fill="#B0E3F4"
                />
                <path
                  d="M147.8896,152.5029 C147.8896,157.7479 143.6376,161.9999 138.3916,161.9999 C133.1466,161.9999 128.8946,157.7479 128.8946,152.5029 C128.8946,147.2569 133.1466,143.0049 138.3916,143.0049 C143.6376,143.0049 147.8896,147.2569 147.8896,152.5029"
                  fill="#75CFEC"
                />
                <path
                  d="M142.9902,152.5029 C142.9902,155.0419 140.9312,157.1009 138.3912,157.1009 C135.8522,157.1009 133.7942,155.0419 133.7942,152.5029 C133.7942,149.9629 135.8522,147.9039 138.3912,147.9039 C140.9312,147.9039 142.9902,149.9629 142.9902,152.5029"
                  fill="#B0E3F4"
                />
                <path
                  d="M148.667,31 L148.667,107.095"
                  stroke="#DADADA"
                  strokeWidth="4"
                />
                <path
                  d="M114.4443,31 L118.7773,112.719"
                  stroke="#DADADA"
                  strokeWidth="4"
                />
                <path
                  d="M81.8887,31 L88.2227,117.02"
                  stroke="#DADADA"
                  strokeWidth="4"
                />
                <path
                  d="M49.333,31 L57.667,119.667"
                  stroke="#DADADA"
                  strokeWidth="4"
                />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

StoreCart.displayName = "StoreCart";
StoreCart.vstuiName = "Icon";

export default StoreCart;
